<template>
  <svg
    :width="size"
    :height="size"
    viewBox="0 0 21 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M20.1867 13.2146C20.392 12.4029 20.5 11.5527 20.5 10.675C20.5 5.0552 16.0231 0.5 10.5 0.5C4.97686 0.5 0.5 5.05703 0.5 10.6768C0.5 11.5545 0.609851 12.4047 0.813344 13.2164M1.10328 16.0254C0.712498 16.3809 0.5 16.7657 0.5 17.1688C0.5 19.0085 4.97686 20.5 10.5 20.5C16.0231 20.5 20.5 19.0085 20.5 17.1688C20.5 16.784 20.3037 16.4139 19.9435 16.0694M2.92392 13.2531C2.92392 12.6814 3.14722 12.1335 3.5452 11.7286C3.94318 11.3236 4.48163 11.0964 5.04349 11.0964C5.60535 11.0964 6.1438 11.3236 6.54178 11.7286C6.93976 12.1335 7.16307 12.6814 7.16307 13.2531V14.1766H6.25545L5.95291 16.6393H4.13767L3.83513 14.1766H2.92752V13.2531H2.92392ZM12.6178 8.95625C12.6178 8.38456 12.3945 7.83669 11.9965 7.43175C11.5985 7.0268 11.0601 6.79959 10.4982 6.79959C9.93634 6.79959 9.39789 7.0268 8.99991 7.43175C8.60193 7.83669 8.37862 8.38456 8.37862 8.95625V9.87975H9.28624L9.58878 12.3424H11.404L11.7066 9.87975H12.6142V8.95625H12.6178ZM18.0761 13.2531C18.0761 12.6814 17.8528 12.1335 17.4548 11.7286C17.0568 11.3236 16.5184 11.0964 15.9565 11.0964C15.3947 11.0964 14.8562 11.3236 14.4582 11.7286C14.0602 12.1335 13.8369 12.6814 13.8369 13.2531V14.1766H14.7446L15.0471 16.6393H16.8623L17.1649 14.1766H18.0725V13.2531H18.0761ZM5.04169 11.0983C4.37358 11.0983 3.83153 10.5467 3.83153 9.86693C3.83153 9.18713 4.37358 8.63559 5.04169 8.63559C5.7098 8.63559 6.25185 9.18713 6.25185 9.86693C6.25185 10.5467 5.7098 11.0983 5.04169 11.0983ZM10.5 6.80142C11.1681 6.80142 11.7102 6.24989 11.7102 5.57009C11.7102 4.89029 11.1681 4.33875 10.5 4.33875C9.83189 4.33875 9.28984 4.89029 9.28984 5.57009C9.28984 6.24989 9.83189 6.80142 10.5 6.80142ZM15.9583 11.0983C16.6264 11.0983 17.1685 10.5467 17.1685 9.86693C17.1685 9.18713 16.6264 8.63559 15.9583 8.63559C15.2902 8.63559 14.7482 9.18713 14.7482 9.86693C14.7482 10.5467 15.2902 11.0983 15.9583 11.0983Z"
      :stroke="color"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>

<script setup lang="ts">
withDefaults(
  defineProps<{
    size?: number;
    color?: string;
  }>(),
  {
    size: 56,
    color: "#D0A444",
  },
);
</script>
